import React from 'react';

const TRANSACTION_STATUS = {
  0: { label: 'Pending', variant: 'warning' },
  1: { label: 'Successful', variant: 'success' },
  2: { label: 'Failed', variant: 'danger' },
};

export function StatusPill({ label, variant = 'neutral' }) {
  return (
    <span className={`status-pill status-pill--${variant}`} aria-label={label}>
      {label}
    </span>
  );
}

// Render transaction.status (0/1/2) as a pill. Unknown codes fall back to neutral.
export function TransactionStatusPill({ code }) {
  const mapped = TRANSACTION_STATUS[code] ?? { label: `Status ${code ?? '—'}`, variant: 'neutral' };
  return <StatusPill label={mapped.label} variant={mapped.variant} />;
}

export function SettledPill({ settled }) {
  return settled
    ? <StatusPill label="Yes" variant="success" />
    : <StatusPill label="No" variant="neutral" />;
}

// Pay-with-Transfer fee state from transaction.metadata.charge.status.
// No charge configured (missing status) renders a muted dash, not a pill.
const CHARGE_STATUS = {
  pending: { label: 'Pending', variant: 'warning' },
  succeeded: { label: 'Charged', variant: 'success' },
  failed: { label: 'Failed', variant: 'danger' },
};

export function ChargePill({ status }) {
  if (!status) return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  const mapped = CHARGE_STATUS[status] ?? { label: status, variant: 'neutral' };
  return <StatusPill label={mapped.label} variant={mapped.variant} />;
}

// Active/inactive flag — same pill in terminals, merchants, staff tables.
export function ActivePill({ active }) {
  return active
    ? <StatusPill label="Active" variant="success" />
    : <StatusPill label="Inactive" variant="danger" />;
}

export default StatusPill;
